import { isDevMode } from '@angular/core'

export const injectGoogleAnalytics = (): void => {
  if (!isDevMode()) {
    const config = document.createElement('script')
    config.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-KTZ9F74');`

    const beforeBodyEnd = document.createElement('noscript')
    beforeBodyEnd.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KTZ9F74"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`

    document.head.appendChild(config)
    document.body.appendChild(beforeBodyEnd)
  }
}
